import {createStore, combineReducers} from 'redux';
import menuReducer from '../reducers/menu-reducer';
import categorieReducer from '../reducers/categorie-reducer';

const allReducers = combineReducers({
    menu: menuReducer,
    categorie: categorieReducer,
});

const store = createStore(allReducers, {
    menu: null,
    categorie: null
});

export default store;


// WEBPACK FOOTER //
// ./src/container/store/store.js